import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-four-o-mini',
  templateUrl: './four-o-mini.component.html',
  styleUrls: ['./four-o-mini.component.scss']
})
export class FourOMiniComponent {
  constructor(public dialogRef: MatDialogRef<FourOMiniComponent>) {}

  close(): void {
    this.dialogRef.close();
  }
}
